export const loginSectionStruct = {
  align: "center",
  wrap: "wrap",
  justify: "center",
  vertical: true,
  gap: "middle",

  style: {
    background: "white",
    position: "relative",
    zIndex: 1,
    height: "600px",

    padding: "32px",

    borderRadius: "16px",
    boxShadow: "rgb(9 5 41) 0px 0px 1px",
  },
};

export const loginBannerStruct = {
  style: {
    minWidth: "100px",
    maxWidth: "100px",
    background: "white",
    borderRadius: "500px",
    boxShadow: "black 0px 0px 1px",
  },
};

export const loginFormStruct = {
  labelAlign: "left",

  autoComplete: "on",
  style: {
    padding: "32px",
  },
};

export const emailFieldStruct = {
  name: "email",
  rules: [
    {
      type: "email",
      required: true,
      message: "Please input your email!",
    },
  ],
};

export const passwordFieldStruct = {
  name: "password",
  rules: [
    {
      required: true,
      message: "Please input your password!",
    },
  ],
};

export const buttonSectionStruct = {};

export const buttonStruct = {
  type: "primary",
  htmlType: "submit",
  block: true,
};

export const homeSectionTitle = {
  style: {
    fontSize: "24px",
    fontWeight: "400",
    color: "#1c1f7f",
    align: "center",
    whiteSpace: "wrap",
    textAlign: "center",
  },
};

export const homeSectionSemiTitle = {
  style: {
    fontSize: "17px",
    fontWeight: "400",
    color: "#1c1f7f",
    align: "center",
    whiteSpace: "wrap",
    textAlign: "center",
  },
};

export const forgetPassStruct = {
  style: {
    float: 'right',
    color: "#1c1f7f",
    marginTop: '10px'
  }
}
